import { useLayoutEffect } from 'react';

const MARK = 'data-vyomos-global-theme';

// Site-wide theme from Website → Global Theme. Accepts plain CSS, or HTML with
// <style>/<link>/<script> tags (e.g. a font link + stylesheet). Injected once into <head>.
export function GlobalThemeStyles({ css }) {
  useLayoutEffect(() => {
    document.head.querySelectorAll(`[${MARK}]`).forEach((n) => n.remove());
    const src = (css || '').trim();
    if (!src) return undefined;
    const nodes = [];
    if (!src.startsWith('<')) {
      const style = document.createElement('style');
      style.textContent = src;
      nodes.push(style);
    } else {
      const tpl = document.createElement('template');
      tpl.innerHTML = src;
      tpl.content.childNodes.forEach((n) => {
        if (n.nodeType !== 1) return;
        const tag = n.tagName.toLowerCase();
        const el = document.createElement(tag === 'script' || tag === 'link' || tag === 'meta' ? tag : 'style');
        [...n.attributes].forEach((a) => el.setAttribute(a.name, a.value));
        el.textContent = n.textContent;
        nodes.push(el);
      });
    }
    nodes.forEach((n) => { n.setAttribute(MARK, ''); document.head.appendChild(n); });
    return () => nodes.forEach((n) => n.remove());
  }, [css]);
  return null;
}

export default GlobalThemeStyles;
